export default __webpack_public_path__ + "static/jack_avatar-0b7950ab71644134cfc6f516a000704c.png";